import logo from './logo.svg';
import './App.css';
import Navbar from './component/Navbar';
import { BrowserRouter } from 'react-router-dom';
import Footer from './component/Footer';

import AllRoutes from './AllRoutes';

function App() {
  return (
    <BrowserRouter>
    
   <AllRoutes/>
    
    </BrowserRouter>
  );
}

export default App;
